export default __webpack_public_path__ + "static/media/reims18.5ece2aef.jpg";